import React, { useEffect } from 'react';
import { useNotify } from '../../context/NotificationContext';
import { Form, Input, Button, Card, Switch, Row, Col, Typography, Divider, Select } from 'antd';
import { SaveOutlined, ArrowLeftOutlined, FileTextOutlined } from '@ant-design/icons';
import { noWhitespaceValidator } from '../../utils/commonFunctions';

const { TextArea } = Input;
const { Title, Text } = Typography;
const { Option } = Select;

const TemplateForm = ({
  initialValues = {},
  loading = false,
  onSubmit,
  onBack,
  isEdit = false,
}) => {
  const [form] = Form.useForm();
  const notify = useNotify();

  useEffect(() => {
    console.log("initialValues",initialValues);
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue({
        name: initialValues.temp_name,
        description: initialValues.temp_description,
        type: initialValues.temp_type,
        is_active: initialValues.is_active ?? true,
      });
    }
  }, [initialValues, form]);

  const handleSubmit = async (values) => {
    try {
      console.log("handleSubmit",values);
       await onSubmit(values);
    } catch (error) {
      console.error("Error adding template:", error);
      notify.error({
        message: "Failed to add template",
      });
    }
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      {/* Beautiful Header Card */}
      <Card 
        style={{ 
          marginBottom: 24,
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          border: '1px solid #f0f0f0'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <div style={{
            width: 64,
            height: 64,
            borderRadius: 16,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 16px rgba(102, 126, 234, 0.3)'
          }}>
            <FileTextOutlined style={{ color: '#fff', fontSize: '28px' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <Button 
                icon={<ArrowLeftOutlined />} 
                onClick={onBack}
                type="text"
                size="small"
                style={{ color: '#8c8c8c' }}
              >
                Back to Templates
              </Button>
            </div>
            <Title level={3} style={{ margin: 0, color: '#262626' }}>
              {isEdit ? 'Edit Template' : 'Create New Template'}
            </Title>
            <Text type="secondary" style={{ fontSize: '14px', marginTop: 4, display: 'block' }}>
              {isEdit 
                ? 'Update template information and settings' 
                : 'Create a new template for your pages and layouts'
              }
            </Text>
          </div>
        </div>
      </Card>

      {/* Beautiful Form Card */}
      <Card 
        style={{ 
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          border: '1px solid #f0f0f0'
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={[24, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontWeight: 600, color: '#262626' }}>Template Name</span>}
                name="name"
                rules={[
                  { required: true, message: 'Please enter template name' },
                  { min: 2, message: 'Template name must be at least 2 characters' },
                  { max: 100, message: 'Template name cannot exceed 100 characters' },
                  { validator: noWhitespaceValidator },
                ]}
              >
                <Input 
                  placeholder="Enter template name"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontWeight: 600, color: '#262626' }}>Template Type</span>}
                name="type"
                rules={[
                  { required: true, message: 'Please select template type' }
                ]}
              >
                <Select 
                  placeholder="Select template type"
                  size="large"
                  style={{ borderRadius: 8 }}
                >
                  <Option value="Page">Page</Option>
                  <Option value="Section">Section</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label={<span style={{ fontWeight: 600, color: '#262626' }}>Description</span>}
            name="description"
          >
            <TextArea 
              placeholder="Enter template description (optional)"
              rows={4}
              maxLength={500}
              showCount
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Row gutter={[24, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontWeight: 600, color: '#262626' }}>Status</span>}
                name="is_active"
                valuePropName="checked"
                initialValue={false}
              >
                <Switch 
                    // checkedChildren="Active" 
                    // unCheckedChildren="Inactive"
                    style={{ marginRight: 12 }}
                  />
              </Form.Item>
            </Col>
          </Row>

          <Divider style={{ margin: '32px 0' }} />

          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            padding: '16px 0'
          }}>
            <Button 
              onClick={onBack}
              size="large"
              style={{ borderRadius: 8 }}
            >
              Cancel
            </Button>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              icon={<SaveOutlined />}
              size="large"
              style={{
                borderRadius: 8,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                fontWeight: 500,
                minWidth: 160
              }}
            >
              {isEdit ? 'Update Template' : 'Create Template'}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default TemplateForm;
